module.exports = __webpack_public_path__ + "img/s-about-us-img4-1.4c3f3969.jpg";